/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { AuthGuard } from '../auth.guard';

import { ConfigComponent } from '../config/config.component';

import { EnrichComponent } from '../config/enrich/enrich.component';
import { RouteTrackComponent } from '../config/route-track/route-track.component';
import { RouteTrackDetailComponent } from '../config/route-track/route-track-detail.component';

import { WorkflowsComponent } from '../config/workflows/workflows.component';
import { WFDetailComponent } from '../config/workflows/wf-detail.component';
import { WfDetailPardotComponent } from '../config/workflows/wf-detail-pardot/wf-detail-pardot.component';
import { WFActonDetailComponent } from '../config/workflows/wf-acton-detail.component';
import { AlertWfDetailComponent } from '../config/workflows/alert-wf-detail.component';
import { WorkflowHistoryComponent } from '../config/workflows/workflow-history/workflow-history.component';
import {CdoComponent} from '../config/cdo/cdo.component';
import {CdoDetailComponent} from '../config/cdo/cdo-detail.component';

export const configRouterConfig = [
  {
    path: 'config',
    component: ConfigComponent,
    canActivate: [AuthGuard],
    data: { role: 'manager', title: 'SyncRoute', uiTitle: 'Sync & Route' }
  },
  {
    path: 'config/enrich',
    component: EnrichComponent,
    canActivate: [AuthGuard],
    data: { role: 'contributor', title: 'Enrich', uiTitle: 'Enrich' }
  },
  {
    path: 'config/routetrack',
    component: RouteTrackComponent,
    canActivate: [AuthGuard],
    data: { role: 'contributor', title: 'Route & Track', uiTitle: 'Route & Track' }
  },
  {
    path: 'config/routetrack/:id',
    component: RouteTrackDetailComponent,
    canActivate: [AuthGuard],
    data: { role: 'contributor', title: 'Routing Rules', uiTitle: 'Routing Rules' }
  },
  {
    path: 'config/workflows',
    component: WorkflowsComponent,
    canActivate: [AuthGuard],
    data: { role: 'user', title: 'Workflows', uiTitle: 'Workflows' }
  },
  {
    path: 'config/workflows/history/:id',
    component: WorkflowHistoryComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Workflow History', uiTitle: 'Workflow History' }
  },
  {
    path: 'config/workflows/siftrock/:id',
    component: AlertWfDetailComponent,
    canActivate: [AuthGuard],
    data: { role: 'manager', title: 'Alert Workflow', uiTitle: 'Alert Workflow' }
  },
  {
    path: 'config/workflows/acton/:id',
    component: WFActonDetailComponent,
    canActivate: [AuthGuard],
    data: { role: 'manager', title: 'Edit Workflow', uiTitle: 'Edit Workflow' }
  },
  {
    path: 'config/workflows/pardot/:id',
    component: WfDetailPardotComponent,
    canActivate: [AuthGuard],
    data: { role: 'manager', title: 'Edit Workflow', uiTitle: 'Edit Workflow' }
  },
  {
    path: 'config/workflows/:partner/:id',
    component: WFDetailComponent,
    canActivate: [AuthGuard],
    data: { role: 'manager', title: 'Edit Workflow', uiTitle: 'Edit Workflow' }
  },
  {
    path: 'config/cdo',
    component: CdoComponent,
    canActivate: [AuthGuard],
    data: { role: 'manager', title: 'Eloqua CDO Sync', uiTitle: 'Eloqua Custom Object Sync' }
  },
  {
    path: 'config/cdo/:id',
    component: CdoDetailComponent,
    canActivate: [AuthGuard],
    data: { role: 'manager', title: 'Edit CDO Sync', uiTitle: 'Edit Custom Object Sync' }
  }
];



// WEBPACK FOOTER //
// ./client/app/routes/config.routes.ts